
























































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, Getter, Mutation, State} from 'vuex-class'
import MenuEntry from '@/modules/cms/modules/menu/model/MenuEntry'
import MenuType from '@/modules/cms/modules/menu/model/MenuType'
import MenuEntryTranslation from '@/modules/cms/modules/menu/model/MenuEntryTranslation'
import {isHttpUri} from 'valid-url'
import {Prop, Watch} from 'vue-property-decorator';
import PageSearch from '@/modules/cms/components/PageSearch.vue'
import {Page} from '@/modules/cms/types'
import ProductListDialog from '@/modules/product/components/ProductListDialog.vue'
import {Product} from '@/modules/product'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {Colors, notify} from '@/modules/core/notification'
import TagAutocomplete from '@/modules/blog/components/tag/TagAutocomplete.vue';
import ColorPickerField from '@/components/ColorPickerField.vue';
import SizeInput from '@/components/SizeInput.vue';

export interface VForm extends Vue {
    validate (): boolean

    reset (): void
}

export interface EntryType {
    text: string
    type: string
    contentType?: string
    icon: string
}

/**
 * Muestra al usuario la pantalla para la modificación de los detalles de un elemento
 * de menu.
 *
 * Permite modificar:
 * - Nombre y título del elemento
 * - Si es un enlace, el links al que dirige, si es un puntero a una página,
 *   permite cambiar el id al que hace referencia
 * - Modificar los estilos del elemento
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        SizeInput,
        ColorPickerField,
        TagAutocomplete,
        PageSearch,
        ProductListDialog,
    },
})
export default class MenuItemDetail extends Vue {
    public $refs: {
        form: VForm,
    }

    /**
     * Alto máximo
     *
     * Si se activa el componente intentará todo el espacio vertical que permite el
     * contenedor padre
     */
    @Prop({type: Boolean, default: false})
    public fullHeight: boolean

    /**
     * Indica si el usuario esta creando un nuevo elemento de menú
     */
    @State(state => state.cms.menu.creatingItem)
    public creatingItem: boolean

    /**
     * Indica si el usuario ha seleccionado alguno de los elementos de menú disponibles
     * en la pantalla del árbol de elementos
     */
    @State(state => state.cms.menu.itemSelected)
    public itemSelected: boolean

    /**
     * Elemento actualmente seleccionado por el usuario o en proceso de
     * creación
     */
    @State(state => state.cms.menu.currentMenuItem)
    public item: MenuEntry

    /**
     * Si el usuario ha elegido la opción de crear un nuevo elemento, esta propiedad
     * almacena el id temporal del padre donde debe insertarse el nuevo elemento
     */
    @State(state => state.cms.menu.newItemInsertionPoint)
    public newItemInsertionPoint: string

    /**
     * Mutación que permite establece el elemento de menú actualmente seleccionado
     */
    @Mutation('cms/menu/current/item/set')
    public setCurrentMenuItem: (item: MenuEntry) => void

    /**
     * Traducción del elemento de menú actualmente seleccionada por el usuario
     */
    @Getter('cms/menu/currentTranslation')
    public currentTranslation: MenuEntryTranslation

    /**
     * Mutación que permite insertar el elemento actualmente en edición como hijo
     * de otro elemento en el menú principal actual
     */
    @Mutation('cms/menu/ADD_CURRENT_ITEM_TO_MENU')
    public addItemToMenu: (parent: string) => void

    /**
     * Habilita o des-habilita la opción que indica si el usuario ha seleccionado algún
     * elemento de menú
     */
    @Mutation('cms/menu/TOGGLE_ITEM_SELECTED')
    public toggleItemSelected: (selected: boolean) => void

    /**
     * Si el elemento es seleccionado o de-seleccionado se limpia el formulario
     */
    @Watch('itemSelected')
    public onItemSelectedChange (selected: boolean) {
        // this.$refs.form.reset()
    }

    public routeName = ''

    /**
     * Tamaños de pantalla para personalizar estilos
     */
    public screenSizes = [
        { id: 'desktop', name: 'Escritorio', icon: 'mdi-monitor' },
        { id: 'tablet', name: 'Tablet', icon: 'mdi-tablet' },
        { id: 'smartphone', name: 'Smartphone', icon: 'mdi-cellphone' },
    ]

    public currentSize = 0

    public get selectedSize () {
        return this.screenSizes[this.currentSize]
    }

    /**
     * Permite obtener el estilo
     */
    public get style () {
        return this.item.styles[this.selectedSize.id] || {}
    }

    /**
     * Actualiza el valor de uno de los parámetros de estilos del tamaño
     * seleccionado por el usuario
     */
    public updateStyle (name: string, value: any) {
        this.update(`styles.${this.selectedSize.id}.${name}`, value)
    }

    /**
     * Tipos de menus disponibles para que el usuario seleccione
     */
    public entryTypes = [
        {
            id: 'link',
            text: 'Enlace',
            type: MenuType.Link,
            icon: 'link',
        },
        {
            id: 'collection',
            text: 'Grupo de elementos',
            type: MenuType.Collection,
            icon: 'menu',
        },
        {
            id: 'resource.page.static',
            text: 'Página',
            type: MenuType.Resource,
            contentType: 'page.static',
            icon: 'find_in_page',
        },
        // {
        //     id: 'resource.shop.product',
        //     text: 'Producto',
        //     type: MenuType.Resource,
        //     contentType: 'shop.product',
        //     icon: 'shopping_cart'
        // },
        // {
        //     id: 'resource.blog.post',
        //     text: 'Artículo del blog',
        //     type: MenuType.Resource,
        //     contentType: 'blog.post',
        //     icon: 'edit'
        // },
    ]

    public get resourceTypes () {
        return [
            {
                text: 'Página estática',
                value: 'page.static',
                finderComponent: 'PageSearch',
                componentProps: {
                    id: this.item.resourceId,
                },
            },
            {
                text: 'Producto',
                value: 'shop.product',
                finderComponent: 'ProductListDialog',
                componentProps: {
                    allowEdit: false,
                    showLoadingScreen: false,
                    allowSelect: true,
                },
            },
        ]
    }

    public valid = true
    public resourceSearch = false
    public resourceName = ''
    public loadingName = false
    public loadingLink = false

    /**
     * Retorna el tipo de menu actualmente seleccionado por el usuario en el componente
     * de selección de tipo
     */
    public get currentMenuEntry () {
        return this.entryTypes.find(entry => {
            if (this.item.resourceType) {
                return this.item.type === entry.type && this.item.resourceType === entry.contentType
            }

            return this.item.type === entry.type
        })
    }

    public get resourceType () {
        if (this.item.type !== MenuType.Resource) {
            return null
        }

        return this.resourceTypes.find(rt => rt.value === this.item.resourceType)
    }

    /**
     * Método invocado cuando el usuario cambia el tipo de entrada de menú
     */
    public onEntryTypeChange (type: EntryType) {
        this.update('type', type.type)
        this.update('resourceType', type.contentType || '')
        // Resetea el id de la entidad
        this.update('resourceId', '')
    }

    public validationRules = {
        name: [
            (v: string) => !!v || 'El nombre del menú no puede estar vacío',
        ],
        type: [
            (v: string) => (!!v && v !== MenuType.None) || 'El tipo de menú es obligatorio',
        ],
        link: [
            (v: string) => (!!v && !!isHttpUri(v)) || 'La url del enlace no es válida',
        ],
    }

    /**
     * Guarda los cambios, inserta el elemento si es nuevo o actualiza el actual
     */
    public save () {
        if (!this.$refs.form.validate()) {
            return
        }

        // Si el elemento es nuevo, se inserta directamente en el menu
        if (this.creatingItem) {
            this.addItemToMenu(this.newItemInsertionPoint)
        }

        this.$emit('save', {newItem: this.creatingItem, id: this.item.tempId})
    }

    /**
     * Actualiza un campo del elemento actual
     */
    public update (path: string, value: any) {
        this.$store.commit('cms/menu/current/item/field/update', {path, value})
    }

    /**
     * Actualiza un campo de la traducción actualmente seleccionada por el usuario
     */
    public updateTranslation (path: string, value: any) {
        this.$store.commit('cms/menu/current-item/translation/field/update', {path, value})
    }

    public async onResourceSelect (resource: KeyValuePair) {
        this.update('resourceId', resource.id)
        switch (true) {
            case resource instanceof Page:
                this.resourceName = (resource as Page).title
                this.routeName = resource.route
                break
            case resource instanceof Product:
                this.resourceName = (resource as Product).name
                break
        }

        this.resourceSearch = false

        await this.loadLink()
    }

    /**
     * Cancela la edición o creación de un menú
     */
    public cancel () {
        this.setCurrentMenuItem(new MenuEntry())
        this.toggleItemSelected(false)
        this.$emit('cancel')
    }

    /**
     * Carga enlace
     */
    public async loadLink () {
        this.loadingLink = true
        try {
            await this.$store.dispatch('cms/menu/loadCurrentMenuItemLink')
        } catch (e) {
            notify(e.message, Colors.Error)
        }

        this.loadingLink = false
    }
        }
